import { commonServerInstance } from '@/utilities/instances'
import { commonDownloadService } from './common'

export const fetchCARateCardManagement = async (filters: any) => {
  const response = await commonServerInstance.post(
    '/api/v1/ca/rate-card/partner-rate-card-config/search',
    filters
  )
  return response?.data?.data
}

export const templateUrl = {
  zone: '/api/v1/ca/rate-card/templates/zone',
  price: '/api/v1/ca/rate-card/templates/price'
}

export const downloadZoneFile = async (id: string, name: string) => {
  const response = await commonDownloadService(
    `/api/v1/ca/rate-card/partner-rate-card-config/${id}/download-zone`,
    name
  )
  return response?.data?.data
}

export const downloadPriceFile = async (id: string, name: string) => {
  const response = await commonDownloadService(
    `/api/v1/ca/rate-card/partner-rate-card-config/${id}/download-price`,
    name
  )
  return response?.data?.data
}

export const addRateCard = async (params: any) => {
  const response = await commonServerInstance.post(
    '/api/v1/ca/rate-card/add',
    params
  )
  return response?.data?.data
}

export const fetchCarrierByPartner = async (id: string) => {
  const response = await commonServerInstance.get(
    `/api/v1/ca/rate-card/partner-config/${id}/carriers`
  )
  return response?.data?.data
}

export interface CARateCardDetailRateCard {
  id: number | null
  rate_card_desc: string | null
  weight_uom: string | null
  origin_type: string | null
  origin_const_value: string | null
  destination_type: string | null
  has_remote_area: boolean | number
  has_partner_area: boolean | number
  dimension_uom: string | null
  dim_factor: string | null
  is_delete: boolean
}

export interface CARateCardDetail {
  config_id: number
  partner_id: number
  partner_name: string
  carrier_id: number
  carrier_name: string
  rate_card_id: number
  beg_date: string | null
  end_date: string | null
  update_at: string | null
  is_delete: boolean
  rate_card: CARateCardDetailRateCard | null
}

export const fetchCARateCardDetail = async (
  configId: number | string
): Promise<CARateCardDetail> => {
  const response = await commonServerInstance.get(
    `/api/v1/ca/rate-card/partner-rate-card-config/${configId}`
  )
  return response?.data?.data
}
